import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { CoverImageRaw } from "./CoverImageRaw";
import type { CoverImageInterface } from "./types";

export const Checkout = ({
  paywall,
  coverImageClassName,
  eventImageClassName,
}: CoverImageInterface) => (
  <CoverImageRaw
    paywall={paywall}
    coverImageClassName={classNames(
      "max-h-[303px] rounded-t-xl",
      coverImageClassName,
    )}
    eventImageClassName={eventImageClassName}
  />
);
